import VideoGuestBookContributorVideo from './VideoGuestBookContributorVideo';

export default VideoGuestBookContributorVideo;
